import { lessThan } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const LessThan = BuildValidatorWithComparandDecorator<number>(lessThan, 'DX.FORMS.VALIDATION.ERRORS.LESS_THEN');
